export var EARTH_RADIUS_METERS = 6377830;
export var METERS_PER_MILE = 1609.344;
export var METERS_PER_YARD = 0.9144;
export var METERS_PER_KM = 1000;
